/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-28 11:14:15
 * @LastEditors: yd
 * @LastEditTime: 2020-07-04 15:20:13
 */
import phone from './phone'
import nocharacter from './specialRule'
export default { phone, nocharacter }